import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import addCookieWithConsent from '../../pattern_utilities/addCookieWithConsent';

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// CREATE STRIPE PORTAL SESSION FOR MANAGING EXISTING TEAMS/FIRMS
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////


export const requestCreateTeamStripePortalSession = packet => {
  return {
    type: 'REQUEST_CREATE_TEAM_STRIPE_PORTAL_SESSION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCreateTeamStripePortalSessionSuccess = data => ({
  type: 'RECEIVE_CREATE_TEAM_STRIPE_PORTAL_SESSION_SUCCESS',
  data
})

export const receiveCreateTeamStripePortalSessionFail = data => ({
  type: 'RECEIVE_CREATE_TEAM_STRIPE_PORTAL_SESSION_FAIL',
  data
})

export const tryToCreateTeamStripePortalSession = packet => dispatch => {
  dispatch(requestCreateTeamStripePortalSession(packet));
  
  return fetch('/api/teams/create-portal-session/' + packet.id, {
      method: 'post',
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH)
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      window.location.href = json.url;
      dispatch(receiveCreateTeamStripePortalSessionSuccess(json));
    })
    .catch(e => {
      revokeTokenHandler(e);
      return dispatch(receiveCreateTeamStripePortalSessionFail({errors:e, lastSubmit: packet}));
    })
}



// WEBPACK FOOTER //
// ./src/actions/team/a.t.POST.create-portal-session.js